module.exports = __webpack_public_path__ + "img/download.00bec9a6.png";